import { Autocomplete, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Customer, CustomerBranch } from '../../types/Customer'
import { executeFetch } from '../../helper/Api'
import './CustomerInfo.scss'
import { useLoadingStore } from '../../store/loadingStore'

interface CustomerInfoProps {
  customer : Customer,
  selectedBranch : CustomerBranch,
  setSelectedBranch : (customerBranch : CustomerBranch) => void
}
export default function CustomerInfo({customer,selectedBranch,setSelectedBranch} : CustomerInfoProps) {
    //States
 
    const {setLoading} = useLoadingStore();
    //Actions



    //Effects


  return (
    <div className='customerInfo'>
      <div className='ci-field'>
        <label htmlFor="companyName" >Company:</label>
        <TextField
            id='companyName'
            className="customerText"
            disabled={true}
            value={customer?.companyName}
        />
      </div>
      <div className='ci-field'>
        <label htmlFor="companytin" >TIN:</label>
        <TextField
            id='companytin'
            className="customerText"
            disabled={true}
            value={customer?.tin}
        />
      </div>
     {customer?.branches.length>0 && <div className='ci-field-full'>
        <label htmlFor="companytin" >Select Branch:</label>
        <Autocomplete
            options={customer?.branches}
            value={selectedBranch}
            onChange={(e,v) => setSelectedBranch(v)}
            getOptionLabel={(option) => (option?.street ?? '' + ', ') + (option?.city ?? '' + ', ') +( option?.zip ?? '')}
            disableClearable
            renderInput={(params) => (
                <TextField {...params} placeholder="Select Branch.." />
            )}
        />
      </div>
      }
    <div className='ci-field'>
        <label htmlFor="companytin" >Street:</label>
        <TextField
            id='companytin'
            className="customerText"
            disabled={true}
            value={selectedBranch?.street}
        />
      </div>
      <div className='ci-field'>
        <label htmlFor="companytin" >City:</label>
        <TextField
            id='companytin'
            className="customerText"
            disabled={true}
            value={selectedBranch?.city}
        />
      </div>
      <div className='ci-field'>
        <label htmlFor="companytin" >Zip Code:</label>
        <TextField
            id='companytin'
            className="customerText"
            disabled={true}
            value={selectedBranch?.zip}
        />
      </div>
      <div className='ci-field'>
        <label htmlFor="companytin" >Phone:</label>
        <TextField
            id='companytin'
            className="customerText"
            disabled={true}
            value={selectedBranch?.phone}
        />
      </div>
      <div className='ci-field'>
        <label htmlFor="companytin" >Email:</label>
        <TextField
            id='companytin'
            className="customerText"
            disabled={true}
            value={selectedBranch?.email}
        />
      </div>

    </div>
  )
}

